module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 65
// module chunks = 0